




















































import { Component, Vue } from 'vue-property-decorator'

@Component({
    components: {},
})
export default class App extends Vue {
    private open: boolean = false

    private toggleActive() {
        this.open = !this.open
    }

    private get getActive() {
        return { 'is-active': this.open, '': !this.open }
    }
}
